<div class="inner-mat-dialog cert-manager-dialog flex flex-col">
  <h1 mat-dialog-title class="dialog-title">
    <span class="title-main">Manage Certificates</span>
    <span class="title-sub">{{ data.edgeDeviceId }}</span>
  </h1>

  <mat-dialog-content class="dialog-content">
    <section class="panel upload-panel">
      <div class="panel-header">
        <h3>Upload Certificate</h3>
      </div>

      <div class="panel-body">
        <div class="file-row">
          <input #certFileInput id="cert-file" class="hidden-file-input" type="file" (change)="onFileSelected($event)" [accept]="acceptedCertificateFileTypes" />
          <button mat-button type="button" class="btn-primary btn-sm" (click)="certFileInput.click()">Choose File</button>
          <div class="file-name" *ngIf="selectedFile">{{ selectedFile.name }}</div>
        </div>

        <div class="form-grid">
          <mat-form-field floatLabel="never" class="w-full">
            <label>Certificate Name</label>
            <input matInput [(ngModel)]="certificateName" [pattern]="certificateNamePattern" #certificateNameModel="ngModel" />
            <mat-error *ngIf="certificateNameModel.errors?.['pattern']">
              Invalid characters in certificate name. You can use A-Z, a-z, 0-9, -, ., and /.
            </mat-error>
          </mat-form-field>

          <mat-form-field floatLabel="never" class="w-full">
            <label>Certificate Type</label>
            <mat-select [(ngModel)]="certificateType">
              <mat-option *ngFor="let type of certificateTypes" [value]="type">{{ type }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field floatLabel="never" class="w-full pfx-field" *ngIf="certificateType === 'PFX'">
            <label>PFX Password (optional)</label>
            <input matInput type="password" autocomplete="new-password" [(ngModel)]="pfxPassword" />
          </mat-form-field>
        </div>
      </div>

      <div class="panel-actions">
        <button mat-button type="button" class="btn-primary btn-sm" [disabled]="installing || certificateNameModel.invalid" (click)="uploadCertificate()">
          Upload
        </button>
      </div>
    </section>

    <section class="panel list-panel">
      <div class="panel-header row">
        <h3>Certificates</h3>
        <button mat-mini-fab type="button" class="refresh-btn !bg-transparent !shadow-none hover:!bg-gray-200" [disabled]="loadingList" (click)="refreshCertificates()" aria-label="Refresh Certificates">
          <mat-icon>refresh</mat-icon>
        </button>
      </div>

      <div class="table-wrap">
        <table mat-table [dataSource]="certificates" class="w-full cert-table" *ngIf="certificates.length; else noCertificatesTemplate">
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let cert">{{ cert.name || 'N/A' }}</td>
          </ng-container>

          <ng-container matColumnDef="expiresAtUtc">
            <th mat-header-cell *matHeaderCellDef>Expires</th>
            <td mat-cell *matCellDef="let cert">{{ cert.expiresAtUtc ? (cert.expiresAtUtc | date: 'MMM dd, yyyy hh:mm a') : 'N/A' }}</td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="text-right"></th>
            <td mat-cell *matCellDef="let cert" class="text-right whitespace-nowrap">
              <ng-container *ngIf="consumerPathsMap.get(cert.relativePath) as paths">
                <button
                  *ngFor="let entry of paths"
                  mat-button
                  type="button"
                  class="btn-default btn-sm mr-2"
                  [cdkCopyToClipboard]="entry.path"
                  (cdkCopyToClipboardCopied)="onPathCopied(entry.path)">
                  Copy {{ entry.friendlyName }} Path
                </button>
              </ng-container>
              <button
                mat-button
                type="button"
                class="btn-default btn-sm"
                [disabled]="removingPath === (cert.relativePath || cert.name)"
                (click)="removeCertificate(cert)">
                Remove
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>

      <ng-template #noCertificatesTemplate>
        <div class="empty-state">No certificates found for this device.</div>
      </ng-template>
    </section>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <button mat-button type="button" class="btn-primary btn-md" (click)="dialogRef.close()">Done</button>
  </mat-dialog-actions>
</div>
